import {Controller} from '@hotwired/stimulus';

/**
 * Bouton de divulgation (modèle « disclosure » de l'APG) : démasque ou masque la zone qu'il pilote, tient
 * `aria-expanded` à jour et échange son libellé (« Voir les données » / « Masquer les données »). La zone peut vivre
 * ailleurs que le bouton dans la carte : le contrôleur se pose sur leur ancêtre commun.
 *
 *   <div {{ stimulus_controller('disclosure') }}>
 *     <div id="x" hidden {{ stimulus_target('disclosure', 'panel') }}>…</div>
 *     <button type="button" aria-expanded="false" aria-controls="x" {{ stimulus_target('disclosure', 'button') }}
 *             {{ stimulus_action('disclosure', 'toggle') }}>
 *       <span {{ stimulus_target('disclosure', 'closedLabel') }}>Voir</span>
 *       <span hidden {{ stimulus_target('disclosure', 'openLabel') }}>Masquer</span>
 *     </button>
 *   </div>
 */
export default class extends Controller {
  static targets = ['button', 'panel', 'closedLabel', 'openLabel'];

  toggle() {
    const expanded = this.buttonTarget.getAttribute('aria-expanded') !== 'true';

    this.buttonTarget.setAttribute('aria-expanded', String(expanded));
    this.panelTarget.hidden = !expanded;
    this.closedLabelTargets.forEach((label) => (label.hidden = expanded));
    this.openLabelTargets.forEach((label) => (label.hidden = !expanded));
  }
}
